// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  hmr: false,
  apiUrl: 'https://api.euanagnosto.gr',
  mode: 'development',
  // firebaseConfig: {
  //   apiKey: "AIzaSyBlqoXKIEWffUhsbxv0qzoVB0PFRUtzHnU",
  //   authDomain: "Ευανάγνωστο-399af.firebaseapp.com",
  //   projectId: "Ευανάγνωστο-399af",
  //   storageBucket: "Ευανάγνωστο-399af.appspot.com",
  //   messagingSenderId: "547203781894",
  //   appId: "1:547203781894:web:bcf70c736d676e93f57a87",
  //   measurementId: "G-L8BR4NCJ80"
  // }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
